import { branding, Colour_Tournament } from "./Utils";

export class CarryingStats {
  constructor({
    animate,
    preview,
    update,
    animateOff,
    getVizPage,
    updateVizPage,
    vizSharedMemory,
  }) {
    this.onAir = false;
    this.sendAnimate = animate;
    this.sendAnimateOff = animateOff;
    this.sendPreview = preview;
    this.sendUpdate = update;
    this.getVizPage = getVizPage;
    this.updateVizPage = updateVizPage;
    this.vizSharedMemory = vizSharedMemory;
    this.name = "CarryingStats";
    this.scene = "CarryingStats";
    this.data = [];
    this.page = 7053;
  }

  async preview({ options }) {
    this.onAir = false;
    let xml = await this.getVizPage({ page: this.page }).catch((err) => {
      console.log(err);
    });
    if (xml) {
      xml = Colour_Tournament({ game: options.game, xml });

      // if (options.push_up) {
      //   xml.payload.field.find((item) => {
      //     return item.attr.name === "0000";
      //   }).value = "1";
      // } else {
      try {
        xml.payload.field.find((item) => {
          return item.attr.name === "0000";
        }).value = "0";
      } catch (err) {}
      // }
      xml.payload.field.find((item) => {
        return item.attr.name === "0000104";
      }).value = `Carrying Stats`;
      xml.payload.field.find((item) => {
        return item.attr.name === "0004";
      }).value = "6";
      xml.payload.field.find((item) => {
        return item.attr.name === "006";
      }).value =
        options.game?.home_team?.variables?.alt_badge ||
        options.game?.home_team?.variables?.badge;

      xml.payload.field.find((item) => {
        return item.attr.name === "007";
      }).value =
        options.game?.away_team?.variables?.alt_badge ||
        options.game?.away_team?.variables?.badge;

      xml.payload.field.find((item) => {
        return item.attr.name === "0101";
      }).value = "Completed sets";

      let home_total =
        parseInt(options?.game?.opta_home_team_stats?.["complete_sets"] || 0) +
        parseInt(options?.game?.opta_home_team_stats?.["incomplete_sets"] || 0);

      let away_total =
        parseInt(options?.game?.opta_away_team_stats?.["complete_sets"] || 0) +
        parseInt(options?.game?.opta_away_team_stats?.["incomplete_sets"] || 0);

      xml.payload.field.find((item) => {
        return item.attr.name === "0102";
      }).value =
        (options?.game?.opta_home_team_stats?.["complete_sets"] || 0) +
        "/" +
        home_total;

      xml.payload.field.find((item) => {
        return item.attr.name === "0103";
      }).value =
        (options?.game?.opta_away_team_stats?.["complete_sets"] || 0) +
        "/" +
        away_total;

      xml.payload.field.find((item) => {
        return item.attr.name === "0201";
      }).value = "Carries";

      xml.payload.field.find((item) => {
        return item.attr.name === "0202";
      }).value = options?.game?.opta_home_team_stats?.["carries"] || 0;

      xml.payload.field.find((item) => {
        return item.attr.name === "0203";
      }).value = options?.game?.opta_away_team_stats?.["carries"] || 0;

      xml.payload.field.find((item) => {
        return item.attr.name === "0301";
      }).value = "Metres";

      xml.payload.field.find((item) => {
        return item.attr.name === "0302";
      }).value = (options?.game?.opta_home_team_stats?.["metres"] || 0) + "m";

      xml.payload.field.find((item) => {
        return item.attr.name === "0303";
      }).value = (options?.game?.opta_away_team_stats?.["metres"] || 0) + "m";

      xml.payload.field.find((item) => {
        return item.attr.name === "0401";
      }).value = "Post-contact metres";

      xml.payload.field.find((item) => {
        return item.attr.name === "0402";
      }).value =
        (options?.game?.opta_home_team_stats?.["post_contact_metres"] || 0) +
        "m";

      xml.payload.field.find((item) => {
        return item.attr.name === "0403";
      }).value =
        (options?.game?.opta_away_team_stats?.["post_contact_metres"] || 0) +
        "m";

      xml.payload.field.find((item) => {
        return item.attr.name === "0501";
      }).value = "Errors";

      xml.payload.field.find((item) => {
        return item.attr.name === "0502";
      }).value = options?.game?.opta_home_team_stats?.["errors"] || 0;

      xml.payload.field.find((item) => {
        return item.attr.name === "0503";
      }).value = options?.game?.opta_away_team_stats?.["errors"] || 0;

      xml.payload.field.find((item) => {
        return item.attr.name === "0601";
      }).value = "Offloads";

      xml.payload.field.find((item) => {
        return item.attr.name === "0602";
      }).value = options?.game?.opta_home_team_stats?.["offload"] || 0;

      xml.payload.field.find((item) => {
        return item.attr.name === "0603";
      }).value = options?.game?.opta_away_team_stats?.["offload"] || 0;

      await this.updateVizPage({ page: this.page, data: xml }).catch((err) => {
        console.log(err);
      });

      await this.sendPreview("page:read " + this.page);
    }
  }
  animate({ options }) {
    this.onAir = true;
    this.sendAnimate({ page: this.page });
  }
  animateOff({ options }) {
    this.onAir = false;
    this.sendAnimateOff({ page: this.page });
  }
}
